import ArgonTypography from "components/ArgonTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { GoogleMap, useLoadScript, MarkerF } from "@react-google-maps/api";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ArgonBox from "components/ArgonBox";
import Table from "examples/Tables/Table";
import Card from "@mui/material/Card";
import Footer from "examples/Footer";
import breakpoints from "assets/theme/base/breakpoints";
import { TextField } from "@mui/material";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { Link, useParams } from "react-router-dom";
import tutorTableData from "Views/people/tutor/data/tutorTableData";
import { Box, MenuItem, FormControlLabel, Checkbox } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Paper from "@mui/material/Paper";

import { useState, useEffect } from "react";

import { Grid } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkIcon from "@mui/icons-material/Work";
import { Chip } from "@mui/material";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";

import { Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material";
import { CircularProgress } from "@mui/material";
import Dropdown from "components/CustomDropdown/Dropdown";
import ApnaTabs from "components/ApnaTabs/ApnaTabs";
import TutoProfileCard from "./TutoProfileCard";
import FileUploader from "components/FileUploader/FileUploader";
import axios, { baseURL } from "utils/api";
import { toast } from "react-toastify";
import TeachingPreferenceTableData from "./data/TeachingPrefernceTableData";
import EducationalQualificationTableData from "./data/EducationalQualificationTableData";
import LocationPreferenceTableData from "./data/LocationPreferenceTableData";
import TeachingExperienceTableData from "./data/TeachingExperienceTableData";
import AssessmentIcon from "@mui/icons-material/Assessment";

// Google Maps API Key - Replace with your own key
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "YOUR_GOOGLE_MAPS_API_KEY";

function BasicDetails() {
  // Load Google Maps script
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  });

  // State for all subjects
  const [allSubjects, setAllSubjects] = useState([]);
  // Fetch all subjects for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/subjects`)
      .then((res) => {
        if (res.data.success) {
          // Map to { label, value } for dropdown
          const options = res.data.data.map((subj) => ({ label: subj.name, value: subj._id }));
          setAllSubjects(options);
        }
      })
      .catch((err) => {
        console.error("Error fetching subjects for dropdown:", err);
      });
  }, []);

  // Fetch all boards for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/boards`)
      .then((res) => {
        if (res.data.success) {
          const options = res.data.data.map((board) => ({ label: board.name, value: board._id }));
          setAllBoards(options);
        }
      })
      .catch((err) => {
        console.error("Error fetching boards for dropdown:", err);
      });
  }, []);

  // Fetch all classes for dropdown
  useEffect(() => {
    axios
      .get(`${baseURL}/classes`)
      .then((res) => {
        if (res.data.success) {
          const options = res.data.data.map((cls) => ({ label: cls.name, value: cls._id }));
          setAllClasses(options);
        }
      })
      .catch((err) => {
        console.error("Error fetching classes for dropdown:", err);
      });
  }, []);
  const [aadhaarFiles, setAadhaarFiles] = useState([]);
  const [aadhaarFrontFiles, setAadhaarFrontFiles] = useState([]);
  const [aadhaarBackFiles, setAadhaarBackFiles] = useState([]);
  const [aadhaarFrontPreview, setAadhaarFrontPreview] = useState(null);
  const [aadhaarBackPreview, setAadhaarBackPreview] = useState(null);

  const statusOptions = [
    "Adaptable & Reliable",
    "Demanding or Money-Focused",
    "Rigid or Difficult to Manage",
    "Premium Client Ready",
    "Not Suitable for Premium Clients",
    "Inconsistent or Unreliable",
    "Underconfident or Needs Improvement",
    "Inactive or Seeking Classes",
    "Dedicated & Professional",
    "Patient & Empathetic",
  ];

  const [availability, setavailability] = useState("");
  const [open, setOpen] = useState(false);
  const [experiencePoints, setExperiencePoints] = useState([]);
  const [educationPoints, setEducationPoints] = useState([]);

  // Evaluation states
  const [openEvaluation, setOpenEvaluation] = useState(false);
  const [evaluation, setEvaluation] = useState(null);
  const [savingEvaluation, setSavingEvaluation] = useState(false);
  const [evaluationForm, setEvaluationForm] = useState({
    introduction: 0,
    english: "BASIC",
    englishRating: 1,
    hindiRating: 1,
    tonePitch: "MEDIUM",
    crossQuestions: 1,
    subjectRatings: [],
    startingFromBasics: false,
    smoothExplanations: false,
    lisp: false,
    lispCategory: "",
    remarks: "",
    confidenceLevel: 1,
    personalityWise: "",
  });
  const [statusSelected, setStatusSelected] = useState([]);

  // Approval/Rejection Dialog States
  const [openApprovalDialog, setOpenApprovalDialog] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [approvalForm, setApprovalForm] = useState({
    approvalStatus: "",
    rejectionReason: "",
    badgeLevel: "",
    hourlyRate: "",
    edushalaMargin: "",
  });
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [hourlyRate, setHourlyRate] = useState("");
  const [mode1, setMode1] = useState(""); // Mode of Tuition
  const [level, setLevel] = useState(""); // Level/Badge
  const [phone, setPhone] = useState("");
  const [alternateMobile, setAlternateMobile] = useState("");
  // const [cityAddress, setCityAddress] = useState("");
  // const [stateName, setStateName] = useState("");
  const [gender, setGender] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");

  // Loading state for form submission
  const [updateLoading, setUpdateLoading] = useState(false);
  const [teachingPrefLoading, setTeachingPrefLoading] = useState(false);
  const [eduQualLoading, setEduQualLoading] = useState(false);
  const [locationPrefLoading, setLocationPrefLoading] = useState(false);
  const [teachingExpLoading, setTeachingExpLoading] = useState(false);

  // Teaching Preferences Dialog States
  const [teachingPrefOpen, setTeachingPrefOpen] = useState(false);
  const [allBoards, setAllBoards] = useState([]);
  const [allClasses, setAllClasses] = useState([]);
  const [teachingPreferences, setTeachingPreferences] = useState([]);
  const [refreshTeachingPref, setRefreshTeachingPref] = useState(false);
  const [dataRefreshKey, setDataRefreshKey] = useState(0);

  // Educational Qualifications Dialog States
  const [eduQualOpen, setEduQualOpen] = useState(false);
  const [eduQualifications, setEduQualifications] = useState([]);

  // Educational Qualification marksheet states
  const [eduQualMarksheetFiles, setEduQualMarksheetFiles] = useState({});
  const [eduQualMarksheetPreviews, setEduQualMarksheetPreviews] = useState({});

  // Location Preferences Dialog States
  const [locationPrefOpen, setLocationPrefOpen] = useState(false);
  const [locationPreferences, setLocationPreferences] = useState([]);
  const [selectedLocationIndex, setSelectedLocationIndex] = useState(0);
  const [mapCenter, setMapCenter] = useState({ lat: 28.6139, lng: 77.209 }); // Default to Delhi

  // Teaching Experience Dialog States
  const [teachingExpOpen, setTeachingExpOpen] = useState(false);
  const [teachingExperience, setTeachingExperience] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleTeachingPrefOpen = () => {
    // Always reinitialize teaching preferences from tutor data
    if (
      tutor &&
      (tutor.subjects?.length > 0 || tutor.boards?.length > 0 || tutor.classes?.length > 0)
    ) {
      const maxLength = Math.max(
        tutor.subjects?.length || 0,
        tutor.boards?.length || 0,
        tutor.classes?.length || 0
      );

      const preferences = [];
      for (let i = 0; i < maxLength; i++) {
        preferences.push({
          subject: tutor.subjects?.[i] ? { _id: tutor.subjects[i]._id } : undefined,
          board: tutor.boards?.[i] ? { _id: tutor.boards[i]._id } : undefined,
          class: tutor.classes?.[i] ? { _id: tutor.classes[i]._id } : undefined,
        });
      }
      setTeachingPreferences(preferences);
    } else {
      setTeachingPreferences([{}]);
    }
    setTeachingPrefOpen(true);
  };
  const handleTeachingPrefClose = () => {
    setTeachingPrefOpen(false);
    // Don't reset preferences - keep them for next open
  };

  const handleEduQualOpen = () => {
    // Initialize marksheet states for existing qualifications
    const marksheetPreviews = {};
    const marksheetFiles = {};
    eduQualifications.forEach((qual, index) => {
      if (qual.marksheet) {
        marksheetPreviews[index] = qual.marksheet;
      }
      marksheetFiles[index] = [];
    });
    setEduQualMarksheetPreviews(marksheetPreviews);
    setEduQualMarksheetFiles(marksheetFiles);
    setEduQualOpen(true);
  };
  const handleEduQualClose = () => {
    setEduQualOpen(false);
    setEduQualifications([]);
    setEduQualMarksheetFiles({});
    setEduQualMarksheetPreviews({});
  };

  const handleLocationPrefOpen = () => {
    // Set selected index to 0 (first location)
    setSelectedLocationIndex(0);
    // Set map center to first location if available
    if (
      locationPreferences.length > 0 &&
      locationPreferences[0]?.lat &&
      locationPreferences[0]?.lng
    ) {
      setMapCenter({
        lat: parseFloat(locationPreferences[0].lat),
        lng: parseFloat(locationPreferences[0].lng),
      });
    }
    setLocationPrefOpen(true);
  };
  const handleLocationPrefClose = () => {
    setLocationPrefOpen(false);
    setSelectedLocationIndex(0); // Reset to first location
  };

  const handleTeachingExpOpen = () => setTeachingExpOpen(true);
  const handleTeachingExpClose = () => setTeachingExpOpen(false);

  // Evaluation handlers
  const handleEvaluationOpen = () => setOpenEvaluation(true);
  const handleEvaluationClose = () => setOpenEvaluation(false);

  const fetchEvaluation = async () => {
    try {
      const response = await axios.get(`${baseURL}/tutor-evaluations?tutorId=${id}`);
      if (response.data.success && response.data.data.length > 0) {
        const evalData = response.data.data[0];
        setEvaluation(evalData);

        // Map subjectRatings to use subjectId._id if populated
        const mappedSubjectRatings = (evalData.subjectRatings || []).map((sr) => ({
          subjectId: typeof sr.subjectId === "object" ? sr.subjectId._id : sr.subjectId,
          rating: sr.rating || 1,
        }));

        setEvaluationForm({
          introduction: evalData.introduction || 0,
          english: evalData.english || "BASIC",
          englishRating: evalData.englishRating || 1,
          hindiRating: evalData.hindiRating || 1,
          tonePitch: evalData.tonePitch || "MEDIUM",
          crossQuestions: evalData.crossQuestions || 1,
          subjectRatings: mappedSubjectRatings,
          startingFromBasics: evalData.teachingMethods?.startingFromBasics || false,
          smoothExplanations: evalData.teachingMethods?.smoothExplanations || false,
          lisp: evalData.lisp || false,
          lispCategory: evalData.lispCategory || "",
          remarks: evalData.remarks || "",
          confidenceLevel: evalData.confidenceLevel || 1,
          personalityWise: evalData.personalityWise || "",
        });
      }
    } catch (error) {
      console.error("Error fetching evaluation:", error);
    }
  };

  const handleEvaluationSubmit = async () => {
    try {
      setSavingEvaluation(true);

      // Filter out incomplete subject ratings (only include entries with valid subjectId)
      const validSubjectRatings = evaluationForm.subjectRatings.filter(
        (sr) => sr.subjectId && sr.subjectId.trim() !== ""
      );

      const payload = {
        introduction: evaluationForm.introduction,
        english: evaluationForm.english,
        englishRating: evaluationForm.englishRating,
        hindiRating: evaluationForm.hindiRating,
        tonePitch: evaluationForm.tonePitch,
        crossQuestions: evaluationForm.crossQuestions,
        subjectRatings: validSubjectRatings,
        teachingMethods: {
          startingFromBasics: evaluationForm.startingFromBasics,
          smoothExplanations: evaluationForm.smoothExplanations,
        },
        lisp: evaluationForm.lisp,
        lispCategory: evaluationForm.lispCategory,
        remarks: evaluationForm.remarks,
        confidenceLevel: evaluationForm.confidenceLevel,
        personalityWise: evaluationForm.personalityWise,
      };

      if (evaluation && evaluation._id) {
        await axios.put(`${baseURL}/tutor-evaluations/${evaluation._id}`, payload);
        toast.success("Evaluation updated successfully!");
      } else {
        await axios.post(`${baseURL}/tutor-evaluations`, { ...payload, tutorId: id });
        toast.success("Evaluation created successfully!");
      }

      await fetchEvaluation();
      handleEvaluationClose();

      // Check if tutor onboarding is completed and open approval dialog
      if (tutor?.onboardingStatus === "COMPLETED") {
        setOpenApprovalDialog(true);
      }
    } catch (error) {
      console.error("Error submitting evaluation:", error);
      toast.error(error.response?.data?.message || "Failed to save evaluation");
    } finally {
      setSavingEvaluation(false);
    }
  };

  // Handle Approval/Rejection
  const handleApprovalDialogOpen = () => {
    // Check if evaluation exists
    if (!evaluation || !evaluation._id) {
      toast.error("Please add tutor evaluation first!");
      return;
    }

    // Reset form
    setApprovalForm({
      approvalStatus: "",
      rejectionReason: "",
      badgeLevel: tutor?.tutorLevel || "",
      hourlyRate: tutor?.hourlyRate || "",
      edushalaMargin: tutor?.edushalaMargin || "",
    });
    setOpenApprovalDialog(true);
  };

  const handleApprovalDialogClose = () => {
    setOpenApprovalDialog(false);
  };

  const handleApprovalSubmit = async () => {
    try {
      // Validate form
      if (!approvalForm.approvalStatus) {
        toast.error("Please select Approved or Rejected");
        return;
      }

      if (approvalForm.approvalStatus === "REJECTED" && !approvalForm.rejectionReason) {
        toast.error("Please provide rejection reason");
        return;
      }

      setApprovalLoading(true);

      const payload = {
        approvalStatus: approvalForm.approvalStatus,
      };

      if (approvalForm.approvalStatus === "APPROVED") {
        // Set badge based on level
        if (approvalForm.badgeLevel) {
          payload.tutorLevel = approvalForm.badgeLevel;
          // Auto-assign badge based on level
          const badgeMap = {
            "Level 1": ["VERIFIED"],
            "Level 2": ["VERIFIED", "EXPERIENCED"],
            "Level 3": ["VERIFIED", "EXPERIENCED", "HIGHLY_RATED"],
            "Level 4": ["VERIFIED", "TOP_TUTOR", "EXPERIENCED", "HIGHLY_RATED"],
          };
          payload.badgeEarned = badgeMap[approvalForm.badgeLevel] || [];
        }
        if (approvalForm.hourlyRate) {
          payload.hourlyRate = Number(approvalForm.hourlyRate);
        }
        if (approvalForm.edushalaMargin) {
          payload.edushalaMargin = Number(approvalForm.edushalaMargin);
        }
      } else if (approvalForm.approvalStatus === "REJECTED") {
        payload.rejectionReason = approvalForm.rejectionReason;
        // Automatically set to current date
        payload.rejectedTillDate = new Date().toISOString();
      }

      await axios.post(`${baseURL}/tutor-evaluations/approve/${id}`, payload);

      toast.success(
        `Tutor ${
          approvalForm.approvalStatus === "APPROVED" ? "approved" : "rejected"
        } successfully!`
      );

      handleApprovalDialogClose();

      // Refresh tutor data
      const res = await axios.get(`${baseURL}/tutor?id=${id}`);
      setTutor(res.data.data);
    } catch (error) {
      console.error("Error approving/rejecting tutor:", error);
      toast.error(error.response?.data?.message || "Failed to update tutor status");
    } finally {
      setApprovalLoading(false);
    }
  };

  const toggleStatus = (item) => {
    if (statusSelected.includes(item)) {
      setStatusSelected(statusSelected.filter((i) => i !== item));
    } else {
      setStatusSelected([...statusSelected, item]);
    }
  };

  const { id } = useParams();
  console.log("Tutor ID from URL:", id);

  const [tutor, setTutor] = useState(null);

  useEffect(() => {
    axios
      .get(`${baseURL}/tutor?id=${id}`)
      .then((res) => {
        console.log("Tutor Details API Response:", res.data);
        setTutor(res.data.data);
      })
      .catch((err) => {
        console.error("Error fetching tutor details:", err);
      });

    // Fetch evaluation data
    fetchEvaluation();
  }, [id]);

  console.log("Tutor Details:", tutor);

  useEffect(() => {
    if (tutor) {
      setFullName(tutor.fullName || "");
      setEmail(tutor.email || "");
      // Set subjects as array of IDs
      setSubjects(tutor.subjects?.map((subj) => subj._id) || []);
      setPhone(tutor.phone || "");
      setAlternateMobile(tutor.alternateMobile || "");
      // setCityAddress(tutor.permanentAddress || ""); // response mai cityAddress nahi, permanentAddress use kiya
      // setStateName(tutor.locationPreference?.[0]?.state || ""); // state fetch from locationPreference
      setLevel(tutor.tutorLevel || "");
      setGender(tutor.gender || "");
      setReferralCode(tutor.referral || "");
      setHourlyRate(tutor.hourlyRate || tutor.salary || "");
      setavailability(tutor.availability || "");

      // Set teaching preferences
      if (tutor.subjects?.length > 0 || tutor.boards?.length > 0 || tutor.classes?.length > 0) {
        // Convert parallel array data to preference objects for editing
        const maxLength = Math.max(
          tutor.subjects?.length || 0,
          tutor.boards?.length || 0,
          tutor.classes?.length || 0
        );

        const preferences = [];
        for (let i = 0; i < maxLength; i++) {
          preferences.push({
            subject: tutor.subjects?.[i] ? { _id: tutor.subjects[i]._id } : undefined,
            board: tutor.boards?.[i] ? { _id: tutor.boards[i]._id } : undefined,
            class: tutor.classes?.[i] ? { _id: tutor.classes[i]._id } : undefined,
          });
        }
        setTeachingPreferences(preferences);
      } else {
        setTeachingPreferences([{}]);
      }

      // Set educational qualifications
      setEduQualifications(tutor.educationQualification || []);

      // Set educational qualification marksheet previews
      const marksheetPreviews = {};
      const marksheetFiles = {};
      (tutor.educationQualification || []).forEach((qual, index) => {
        if (qual.marksheet) {
          marksheetPreviews[index] = qual.marksheet;
        }
        // Always initialize as empty array, even if no existing marksheet
        marksheetFiles[index] = [];
      });
      setEduQualMarksheetPreviews(marksheetPreviews);
      setEduQualMarksheetFiles(marksheetFiles);

      console.log("Initialized marksheet files:", marksheetFiles);
      console.log("Initialized marksheet previews:", marksheetPreviews);

      // Set location preferences
      setLocationPreferences(tutor.locationPreference || []);

      // Set teaching experience (backend field: professionalExperience)
      setTeachingExperience(tutor.professionalExperience || tutor.teachingExperience || []);

      // Set Aadhaar document previews
      setAadhaarFrontPreview(tutor.aadhaarDocument?.frontImage || null);
      setAadhaarBackPreview(tutor.aadhaarDocument?.backImage || null);

      // Set additional fields
      setExperiencePoints(tutor.experiencePoints || []);
      setEducationPoints(tutor.educationPoints || []);
    }
  }, [tutor]);

  // Update marksheet states when eduQualifications change
  useEffect(() => {
    if (eduQualOpen) {
      const marksheetPreviews = { ...eduQualMarksheetPreviews };
      const marksheetFiles = { ...eduQualMarksheetFiles };

      // Ensure all qualifications have entries in the marksheet states
      eduQualifications.forEach((qual, index) => {
        if (!(index in marksheetFiles)) {
          marksheetFiles[index] = [];
        }
        if (!(index in marksheetPreviews) && qual.marksheet) {
          marksheetPreviews[index] = qual.marksheet;
        }
      });

      setEduQualMarksheetPreviews(marksheetPreviews);
      setEduQualMarksheetFiles(marksheetFiles);
    }
  }, [eduQualifications, eduQualOpen]);

  const handleUpdateTutor = async (e) => {
    e.preventDefault();
    setUpdateLoading(true);

    // Validate alternate mobile number
    if (alternateMobile && (alternateMobile.length !== 10 || !/^\d+$/.test(alternateMobile))) {
      toast.error("Alternate mobile must be 10 digits");
      setUpdateLoading(false);
      return;
    }

    try {
      // Create FormData for file uploads
      const formData = new FormData();

      // Add text fields
      formData.append("fullName", fullName);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("alternateMobile", alternateMobile);
      formData.append("hourlyRate", hourlyRate);
      // formData.append("permanentAddress", cityAddress);
      formData.append("gender", gender);

      // Add tutor level if selected
      if (level) {
        formData.append("tutorLevel", level);
      }

      // Add referral code if provided
      if (referralCode.trim()) {
        formData.append("referral", referralCode);
      }

      // Add availability
      if (availability) {
        formData.append("availability", availability);
      }

      // Add subjects as JSON array
      const subjectsArray = Array.isArray(subjects) ? subjects : subjects ? [subjects] : [];
      subjectsArray.forEach((subj, index) => {
        formData.append(`subjects[${index}]`, subj);
      });

      // Add location preference
      // formData.append("locationPreference[0][state]", stateName);

      // Add new fields
      experiencePoints.forEach((point) => {
        formData.append("experiencePoints[]", point);
      });
      educationPoints.forEach((point) => {
        formData.append("educationPoints[]", point);
      });

      // Add Aadhaar Front Image if new file is selected
      if (aadhaarFrontFiles.length > 0 && aadhaarFrontFiles[0].file) {
        formData.append("aadhaarFrontImage", aadhaarFrontFiles[0].file);
      }

      // Add Aadhaar Back Image if new file is selected
      if (aadhaarBackFiles.length > 0 && aadhaarBackFiles[0].file) {
        formData.append("aadhaarBackImage", aadhaarBackFiles[0].file);
      }

      const res = await axios.put(`${baseURL}/tutor/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        // Refresh tutor data
        const tutorRes = await axios.get(`${baseURL}/tutor?id=${id}`);
        setTutor(tutorRes.data.data);
        // Force refresh of all table components
        setDataRefreshKey((prev) => prev + 1);
        setRefreshTeachingPref((prev) => !prev);

        // Clear file states
        setAadhaarFrontFiles([]);
        setAadhaarBackFiles([]);

        toast.success("Tutor details updated successfully!");
        handleClose();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update tutor details");
      console.error("Error updating tutor:", err);
      console.error("Error response:", err.response?.data);
    } finally {
      setUpdateLoading(false);
    }
  };

  const handleUpdateTeachingPreferences = (e) => {
    e.preventDefault();
    setTeachingPrefLoading(true);

    // Convert preference objects back to parallel arrays for API
    // Only include preferences that have at least one field filled
    const validPreferences = teachingPreferences.filter(
      (pref) => pref.subject?._id || pref.board?._id || pref.class?._id
    );

    const subjects = validPreferences.map((pref) => pref.subject?._id).filter(Boolean);
    const boards = validPreferences.map((pref) => pref.board?._id).filter(Boolean);
    const classes = validPreferences.map((pref) => pref.class?._id).filter(Boolean);

    const payload = {
      subjects,
      boards,
      classes,
    };

    axios
      .put(`${baseURL}/tutor/${id}`, payload)
      .then((res) => {
        if (res.data.success) {
          // Refresh tutor data
          axios.get(`${baseURL}/tutor?id=${id}`).then((res) => {
            setTutor(res.data.data);
            // Force refresh of all table components
            setDataRefreshKey((prev) => prev + 1);
          });

          // Trigger refresh for teaching preferences table
          setRefreshTeachingPref((prev) => !prev);

          toast.success("Teaching preferences updated successfully!");
          handleTeachingPrefClose();
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to update teaching preferences");
        console.error("Error updating teaching preferences:", err);
      })
      .finally(() => {
        setTeachingPrefLoading(false);
      });
  };

  const handleUpdateEducationalQualifications = async (e) => {
    e.preventDefault();
    setEduQualLoading(true);

    try {
      // Separate existing and new qualifications
      const existingQualifications = eduQualifications.filter((qual) => qual?._id);
      const newQualifications = eduQualifications.filter((qual) => !qual?._id);

      // Update existing qualifications
      const updatePromises = existingQualifications.map(async (qual) => {
        // Get the index in the original eduQualifications array
        const index = eduQualifications.indexOf(qual);

        const formData = new FormData();

        // Extract IDs properly - backend expects ObjectId strings
        const classId = qual?.class?._id || qual?.class || "";
        const boardId = qual?.board?._id || qual?.board || "";

        // Get year - check both field names and ensure it's a valid number
        const yearValue = qual?.completedYear || qual?.yearOfCompletion || "";
        const completedYear = yearValue ? parseInt(yearValue, 10) : new Date().getFullYear();

        // Get school/university name - check both field names
        const schoolUniversity = qual?.schoolUniversity || qual?.schoolUniversityCollege || "";

        console.log(`📝 Updating qualification ${qual._id}:`, {
          classId,
          boardId,
          completedYear,
          schoolUniversity,
          tutorId: id,
        });

        // Append data to FormData
        formData.append("class", classId);
        formData.append("board", boardId);
        formData.append("completedYear", completedYear.toString());
        formData.append("schoolUniversity", schoolUniversity);
        formData.append("tutor", id);

        // Handle marksheet file
        if (eduQualMarksheetFiles[index] && eduQualMarksheetFiles[index].length > 0) {
          formData.append("marksheet", eduQualMarksheetFiles[index][0].file);
        }

        return axios.put(`${baseURL}/education-qualifications/${qual._id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      });

      // Create new qualifications
      const createPromises = newQualifications.map(async (qual) => {
        // Get the index in the original eduQualifications array
        const index = eduQualifications.indexOf(qual);

        const formData = new FormData();

        // Extract IDs properly - backend expects ObjectId strings
        const classId = qual?.class?._id || qual?.class || "";
        const boardId = qual?.board?._id || qual?.board || "";

        // Get year - check both field names and ensure it's a valid number
        const yearValue = qual?.completedYear || qual?.yearOfCompletion || "";
        const completedYear = yearValue ? parseInt(yearValue, 10) : new Date().getFullYear();

        // Get school/university name - check both field names
        const schoolUniversity = qual?.schoolUniversity || qual?.schoolUniversityCollege || "";

        console.log(`➕ Creating new qualification:`, {
          classId,
          boardId,
          completedYear,
          schoolUniversity,
          tutorId: id,
        });

        // Append data to FormData
        formData.append("class", classId);
        formData.append("board", boardId);
        formData.append("completedYear", completedYear.toString());
        formData.append("schoolUniversity", schoolUniversity);
        formData.append("tutor", id);

        // Handle marksheet file
        if (eduQualMarksheetFiles[index] && eduQualMarksheetFiles[index].length > 0) {
          formData.append("marksheet", eduQualMarksheetFiles[index][0].file);
        }

        return axios.post(`${baseURL}/education-qualifications`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      });

      // Wait for all operations to complete
      const [updateResults, createResults] = await Promise.all([
        Promise.all(updatePromises),
        Promise.all(createPromises),
      ]);

      console.log(
        "✅ All qualifications updated:",
        updateResults.map((r) => r.data)
      );
      console.log(
        "✅ All new qualifications created:",
        createResults.map((r) => r.data)
      );

      // Refresh tutor data
      const tutorResponse = await axios.get(`${baseURL}/tutor?id=${id}`);
      setTutor(tutorResponse.data.data);
      setDataRefreshKey((prev) => prev + 1);

      toast.success("Educational qualifications updated successfully!");
      handleEduQualClose();
    } catch (err) {
      const errorMsg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Failed to update educational qualifications";
      toast.error(errorMsg);
      console.error("❌ Error updating educational qualifications:", err);
      console.error("Error response:", err.response?.data);
      console.error("Error details:", {
        status: err.response?.status,
        data: err.response?.data,
        config: err.config?.data,
      });
    } finally {
      setEduQualLoading(false);
    }
  };

  const handleUpdateLocationPreferences = (e) => {
    e.preventDefault();
    setLocationPrefLoading(true);

    // Format the location preferences properly for API
    // Backend accepts: address1, address2, city, state, pinCode, landMark, latitude, longitude
    const formattedLocations = locationPreferences
      .map((location) => {
        // Preserve all existing fields except _id
        const { _id, ...rest } = location;
        const formatted = {
          ...rest, // Keep all existing fields except _id
          addressLine1: location?.addressLine1 || location?.address1 || "",
          address1: location?.addressLine1 || location?.address1 || "",
          lat: location?.lat || undefined,
          lng: location?.lng || undefined,
        };

        // Clean up undefined values
        Object.keys(formatted).forEach((key) => {
          if (formatted[key] === undefined || formatted[key] === "") {
            delete formatted[key];
          }
        });

        return formatted;
      })
      .filter(
        (location) => location.addressLine1 || location.address1 || location.lat || location.lng
      );

    const payload = {
      locationPreference: formattedLocations,
    };

    console.log("Location Preference Payload:", payload);

    axios
      .put(`${baseURL}/tutor/${id}`, payload)
      .then((res) => {
        console.log("Location API Response:", res.data);
        if (res.data.success) {
          axios.get(`${baseURL}/tutor?id=${id}`).then((res) => {
            setTutor(res.data.data);
            setDataRefreshKey((prev) => prev + 1);
          });

          toast.success("Location preferences updated successfully!");
          handleLocationPrefClose();
        }
      })
      .catch((err) => {
        const errorMsg =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Failed to update location preferences";
        toast.error(errorMsg);
        console.error("Error updating location preferences:", err);
        console.error("Error response:", err.response?.data);
      })
      .finally(() => {
        setLocationPrefLoading(false);
      });
  };

  const handleUpdateTeachingExperience = (e) => {
    e.preventDefault();
    setTeachingExpLoading(true);

    // Format the teaching experience properly for API
    // Backend expects: professionalExperience with organization, position, startDate, endDate, etc.
    const formattedExperience = teachingExperience
      .map((exp) => {
        // Map frontend fields to backend fields
        const organization = exp?.organization || exp?.institutionOrganization || "";
        const position = exp?.position || exp?.positionRole || "";
        const startDate = exp?.startDate || (exp?.duration ? new Date().toISOString() : "");
        const endDate = exp?.endDate || "";
        const isCurrentlyWorking = exp?.isCurrentlyWorking || false;
        const description = exp?.description || exp?.subjectTaught || "";
        const experienceType = exp?.experienceType || "TEACHING";
        const classes = exp?.classes?.map((cls) => cls._id || cls) || undefined;
        const boards = exp?.boards?.map((board) => board._id || board) || undefined;
        const subjects = exp?.subjects?.map((subject) => subject._id || subject) || undefined;

        console.log(`📝 Formatting experience:`, {
          organization,
          position,
          startDate,
          endDate,
          isCurrentlyWorking,
          description,
          experienceType,
          classes,
          boards,
          subjects,
        });

        return {
          organization,
          position,
          startDate,
          endDate: endDate || undefined,
          isCurrentlyWorking,
          description,
          experienceType,
          classes,
          boards,
          subjects,
        };
      })
      .filter((exp) => exp.organization && exp.position && exp.startDate); // Required fields check

    // Remove undefined values
    const cleanedExperience = formattedExperience.map((exp) => {
      const cleaned = {};
      Object.keys(exp).forEach((key) => {
        if (exp[key] !== undefined && exp[key] !== "") {
          cleaned[key] = exp[key];
        }
      });
      return cleaned;
    });

    const payload = {
      professionalExperience: cleanedExperience, // Backend field name
    };

    console.log("Teaching Experience Payload:", payload);

    axios
      .put(`${baseURL}/tutor/${id}`, payload)
      .then((res) => {
        console.log("Teaching Experience API Response:", res.data);
        if (res.data.success) {
          axios.get(`${baseURL}/tutor?id=${id}`).then((res) => {
            setTutor(res.data.data);
            setDataRefreshKey((prev) => prev + 1);
          });

          toast.success("Teaching experience updated successfully!");
          handleTeachingExpClose();
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Failed to update teaching experience");
        console.error("Error updating teaching experience:", err);
        console.error("Error response:", err.response?.data);
      })
      .finally(() => {
        setTeachingExpLoading(false);
      });
  };

  //  const {id} = useParams();
  const { columns, rows } = TeachingPreferenceTableData(id, refreshTeachingPref);
  const { columns1, rows1 } = EducationalQualificationTableData(id, dataRefreshKey);
  const { columns2, rows2 } = LocationPreferenceTableData(id, dataRefreshKey);
  const { columns3, rows3 } = TeachingExperienceTableData(id, dataRefreshKey);

  return (
    <ArgonBox>
      {/* <TutoProfileCard/> */}
      <ArgonBox>
        <Grid container mt={2} spacing={2}>
          {/* Profile Header with Image */}
          <Grid item xs={12}>
            <Card
              sx={{
                borderRadius: 2,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                p: 2,
              }}
            >
              <ArgonBox display="flex" alignItems="center" justifyContent="space-between">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <Avatar
                    src={tutor?.profileImage || ""}
                    alt={tutor?.fullName || "Tutor Image"}
                    sx={{
                      width: 60,
                      height: 60,
                      border: "2px solid white",
                    }}
                  />
                  <ArgonBox>
                    <ArgonTypography variant="h6" fontWeight="medium" color="white">
                      {tutor?.fullName}
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>

                {/* Registration Fee Status */}
                <ArgonBox
                  display="flex"
                  alignItems="center"
                  gap={1}
                  sx={{
                    backgroundColor: tutor?.registrationFee
                      ? "rgba(76, 175, 80, 0.2)"
                      : "rgba(255, 152, 0, 0.2)",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    border: tutor?.registrationFee
                      ? "1px solid rgba(76, 175, 80, 0.5)"
                      : "1px solid rgba(255, 152, 0, 0.5)",
                  }}
                >
                  <ArgonBox
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      backgroundColor: tutor?.registrationFee ? "#4caf50" : "#ff9800",
                    }}
                  />
                  <ArgonTypography variant="body2" fontWeight="medium" color="white">
                    Registration Fee: {tutor?.registrationFee ? "Paid" : "Pending"}
                  </ArgonTypography>
                </ArgonBox>
              </ArgonBox>
            </Card>
          </Grid>

          {/* Profile Information */}
          <Grid item xs={12}>
            <Card sx={{ borderRadius: 2, p: 2, boxShadow: 2 }}>
              <ArgonTypography variant="h6" fontWeight="medium" mb={2} color="primary">
                Profile Information
              </ArgonTypography>

              <Grid container spacing={2}>
                {[
                  { label: "Full Name", value: tutor?.fullName, icon: "👤" },
                  {
                    label: "Mode",
                    value: tutor?.modeOfTuition ? tutor?.modeOfTuition : "not yet",
                    icon: "💻",
                  },
                  {
                    label: "Joining Date",
                    value: tutor?.joiningDate
                      ? new Date(tutor.joiningDate).toLocaleDateString()
                      : "N/A",
                    icon: "📅",
                  },
                  {
                    label: "Availability",
                    value: availability,
                    icon: "⏰",
                  },
                  {
                    label: "Hourly Rate",
                    value: tutor?.hourlyRate ? `₹${tutor.hourlyRate}/hr` : "Not Set",
                    icon: "💰",
                  },
                  {
                    label: "Level",
                    value: tutor?.tutorLevel || "Not Set",
                    icon:
                      tutor?.tutorLevel === "Level 4"
                        ? "💎"
                        : tutor?.tutorLevel === "Level 3"
                        ? "🥇"
                        : tutor?.tutorLevel === "Level 2"
                        ? "🥈"
                        : "🥉",
                  },
                  // {
                  //   label: "English Proficiency",
                  //   value: tutor?.englishProficiency || "N/A",
                  //   icon: "📚",
                  // },
                ].map((item, index) => (
                  <Grid item xs={6} sm={4} md={3} key={index}>
                    <ArgonBox
                      sx={{
                        p: 1.5,
                        bgcolor: "#f5f7fa",
                        borderRadius: 2,
                        border: "1px solid #e0e7ff",
                      }}
                    >
                      <ArgonBox display="flex" alignItems="center" gap={1} mb={0.5}>
                        <ArgonBox sx={{ fontSize: "0.9rem" }}>{item.icon}</ArgonBox>
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          {item.label}
                        </ArgonTypography>
                      </ArgonBox>
                      {item.label === "Availability" ? (
                        <Dropdown
                          label=""
                          value={availability}
                          options={[
                            { label: "Available", value: "Available" },
                            { label: "Not Available", value: "Not Available" },
                            { label: "Busy", value: "Busy" },
                          ]}
                          onChange={async (e) => {
                            const newavailability = e.target.value;
                            setavailability(newavailability);
                            try {
                              await axios.put(`${baseURL}/tutor/${id}`, {
                                availability: newavailability,
                              });
                              toast.success("availability updated successfully!");
                            } catch (err) {
                              toast.error("Failed to update availability");
                              console.error("Error updating availability:", err);
                            }
                          }}
                          width="100%"
                        />
                      ) : (
                        <ArgonTypography variant="body2" fontWeight="medium" color="primary">
                          {item.value}
                        </ArgonTypography>
                      )}
                    </ArgonBox>
                  </Grid>
                ))}
                {/* availability Dropdown - removed as it's now in the grid */}{" "}
                {/* Experience Points */}
                {tutor?.experiencePoints?.length > 0 && (
                  <Grid item xs={6} sm={4} md={3}>
                    <ArgonBox
                      sx={{
                        p: 1.5,
                        bgcolor: "#f5f7fa",
                        borderRadius: 2,
                        border: "1px solid #e0e7ff",
                      }}
                    >
                      <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                        <ArgonBox sx={{ fontSize: "0.9rem" }}>📝</ArgonBox>
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          Experience Points
                        </ArgonTypography>
                      </ArgonBox>
                      <ArgonBox>
                        {tutor.experiencePoints.map((point, index) => (
                          <ArgonTypography key={index} variant="body2" color="primary">
                            • {point}
                          </ArgonTypography>
                        ))}
                      </ArgonBox>
                    </ArgonBox>
                  </Grid>
                )}
                {/* Education Points */}
                {tutor?.educationPoints?.length > 0 && (
                  <Grid item xs={6} sm={4} md={3}>
                    <ArgonBox
                      sx={{
                        p: 1.5,
                        bgcolor: "#f5f7fa",
                        borderRadius: 2,
                        border: "1px solid #e0e7ff",
                      }}
                    >
                      <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
                        <ArgonBox sx={{ fontSize: "0.9rem" }}>🎓</ArgonBox>
                        <ArgonTypography variant="caption" color="text" fontWeight="medium">
                          Education Points
                        </ArgonTypography>
                      </ArgonBox>
                      <ArgonBox>
                        {tutor.educationPoints.map((point, index) => (
                          <ArgonTypography key={index} variant="body2" color="primary">
                            • {point}
                          </ArgonTypography>
                        ))}
                      </ArgonBox>
                    </ArgonBox>
                  </Grid>
                )}
              </Grid>

              {/* Action Buttons */}
              <Box display="flex" gap={1} justifyContent="center" mt={2}>
                <ArgonButton
                  onClick={handleOpen}
                  variant="contained"
                  startIcon={<PersonIcon />}
                  color="primary"
                  size="medium"
                >
                  Edit Profile
                </ArgonButton>
                <ArgonButton
                  onClick={handleEvaluationOpen}
                  variant="contained"
                  startIcon={<AssessmentIcon />}
                  color="info"
                  size="medium"
                >
                  {evaluation ? "Edit Evaluation" : "Submit Evaluation"}
                </ArgonButton>
                {tutor?.onboardingStatus === "COMPLETED" && (
                  <ArgonButton
                    onClick={handleApprovalDialogOpen}
                    variant="contained"
                    color="success"
                    size="medium"
                  >
                    Approve/Reject
                  </ArgonButton>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>

        {open && (
          <ArgonBox
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              backdropFilter: "blur(5px)",
            }}
          >
            <ArgonBox
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "20px",
                width: "90%",
                maxWidth: 900,
                maxHeight: "95vh",
                overflowY: "auto",
                boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
                position: "relative",
              }}
            >
              {/* Header */}
              <ArgonBox
                sx={{
                  background: "rgba(255,255,255,0.1)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "20px 20px 0 0",
                  p: 3,
                  borderBottom: "1px solid rgba(255,255,255,0.2)",
                }}
              >
                <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                  <ArgonBox display="flex" alignItems="center" gap={2}>
                    <ArgonBox
                      sx={{
                        background: "rgba(255,255,255,0.2)",
                        borderRadius: "12px",
                        p: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                    </ArgonBox>
                    <ArgonBox>
                      <ArgonTypography variant="h5" fontWeight="medium" color="white">
                        Edit Profile
                      </ArgonTypography>
                      <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                        Update your profile information
                      </ArgonTypography>
                    </ArgonBox>
                  </ArgonBox>
                  <ArgonButton
                    variant="text"
                    onClick={handleClose}
                    sx={{
                      color: "white",
                      minWidth: "40px",
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.1)",
                      "&:hover": { background: "rgba(255,255,255,0.2)" },
                    }}
                  >
                    ×
                  </ArgonButton>
                </ArgonBox>
              </ArgonBox>

              {/* Form Content */}
              <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
                <form onSubmit={handleUpdateTutor}>
                  <Grid container spacing={3}>
                    {/* Editable Fields */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Full Name
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter Full Name"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Email Address
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Subject
                      </ArgonTypography>
                      <Dropdown
                        label=""
                        value={subjects}
                        options={allSubjects}
                        onChange={(e) => {
                          // For multi-select, e.target.selectedOptions
                          const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
                          setSubjects(selected);
                        }}
                        width={"100%"}
                        multiple
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Hourly Rate (₹/hr)
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter Hourly Rate (e.g., 500)"
                        value={hourlyRate}
                        onChange={(e) => setHourlyRate(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Level/Badge
                      </ArgonTypography>
                      <Dropdown
                        label=""
                        value={level}
                        options={[
                          { label: "🥉 Level 1", value: "Level 1" },
                          { label: "🥈 Level 2", value: "Level 2" },
                          { label: "🥇 Level 3", value: "Level 3" },
                          { label: "💎 Level 4", value: "Level 4" },
                        ]}
                        onChange={(e) => setLevel(e.target.value)}
                        width="100%"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Mobile Number
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter mobile number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Alternate Mobile Number
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter alternate mobile number"
                        value={alternateMobile}
                        onChange={(e) => setAlternateMobile(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    {/* <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        City/Address
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter city/address"
                        value={cityAddress}
                        onChange={(e) => setCityAddress(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid> */}

                    {/* <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        State
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter state"
                        value={stateName}
                        onChange={(e) => setStateName(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid> */}

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Gender
                      </ArgonTypography>
                      <Dropdown
                        label=""
                        value={gender}
                        options={[
                          { label: "Male", value: "MALE" },
                          { label: "Female", value: "FEMALE" },
                          { label: "Other", value: "OTHER" },
                        ]}
                        onChange={(e) => setGender(e.target.value)}
                        width="100%"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Referral Code
                      </ArgonTypography>
                      <ArgonInput
                        placeholder="Enter referral code (optional)"
                        value={referralCode}
                        onChange={(e) => setReferralCode(e.target.value)}
                        fullWidth
                        size="medium"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Experience Points
                      </ArgonTypography>
                      {experiencePoints.map((point, index) => (
                        <ArgonBox key={index} display="flex" alignItems="center" mb={1}>
                          <ArgonInput
                            placeholder="Enter experience point"
                            value={point}
                            onChange={(e) => {
                              const newPoints = [...experiencePoints];
                              newPoints[index] = e.target.value;
                              setExperiencePoints(newPoints);
                            }}
                            fullWidth
                            size="small"
                          />
                          <ArgonButton
                            onClick={() => {
                              const newPoints = experiencePoints.filter((_, i) => i !== index);
                              setExperiencePoints(newPoints);
                            }}
                            variant="outlined"
                            color="error"
                            size="small"
                            sx={{ ml: 1 }}
                          >
                            <HighlightOffIcon />
                          </ArgonButton>
                        </ArgonBox>
                      ))}
                      <ArgonButton
                        onClick={() => setExperiencePoints([...experiencePoints, ""])}
                        variant="outlined"
                        color="primary"
                        size="small"
                      >
                        Add Point
                      </ArgonButton>
                    </Grid>

                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Education Points
                      </ArgonTypography>
                      {educationPoints.map((point, index) => (
                        <ArgonBox key={index} display="flex" alignItems="center" mb={1}>
                          <ArgonInput
                            placeholder="Enter education point"
                            value={point}
                            onChange={(e) => {
                              const newPoints = [...educationPoints];
                              newPoints[index] = e.target.value;
                              setEducationPoints(newPoints);
                            }}
                            fullWidth
                            size="small"
                          />
                          <ArgonButton
                            onClick={() => {
                              const newPoints = educationPoints.filter((_, i) => i !== index);
                              setEducationPoints(newPoints);
                            }}
                            variant="outlined"
                            color="error"
                            size="small"
                            sx={{ ml: 1 }}
                          >
                            <HighlightOffIcon />
                          </ArgonButton>
                        </ArgonBox>
                      ))}
                      <ArgonButton
                        onClick={() => setEducationPoints([...educationPoints, ""])}
                        variant="outlined"
                        color="primary"
                        size="small"
                      >
                        Add Point
                      </ArgonButton>
                    </Grid>
                    {/* Aadhaar Front Image */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Aadhaar Front Image
                      </ArgonTypography>
                      {aadhaarFrontPreview && (
                        <ArgonBox mb={2}>
                          <ArgonTypography variant="caption" color="text" mb={1}>
                            Current Image:
                          </ArgonTypography>
                          <ArgonBox>
                            <img
                              src={aadhaarFrontPreview}
                              alt="Aadhaar Front"
                              height="80px"
                              width="140px"
                              style={{
                                border: "1px solid #e0e7ff",
                                borderRadius: "8px",
                                objectFit: "cover",
                              }}
                            />
                          </ArgonBox>
                        </ArgonBox>
                      )}
                      <FileUploader
                        label="Upload New Aadhaar Front"
                        files={aadhaarFrontFiles}
                        setFiles={setAadhaarFrontFiles}
                        accept="image/*"
                        multiple={false}
                        Width="100%"
                        Height={120}
                      />
                    </Grid>

                    {/* Aadhaar Back Image */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Aadhaar Back Image
                      </ArgonTypography>
                      {aadhaarBackPreview && (
                        <ArgonBox mb={2}>
                          <ArgonTypography variant="caption" color="text" mb={1}>
                            Current Image:
                          </ArgonTypography>
                          <ArgonBox>
                            <img
                              src={aadhaarBackPreview}
                              alt="Aadhaar Back"
                              height="80px"
                              width="140px"
                              style={{
                                border: "1px solid #e0e7ff",
                                borderRadius: "8px",
                                objectFit: "cover",
                              }}
                            />
                          </ArgonBox>
                        </ArgonBox>
                      )}
                      <FileUploader
                        label="Upload New Aadhaar Back"
                        files={aadhaarBackFiles}
                        setFiles={setAadhaarBackFiles}
                        accept="image/*"
                        multiple={false}
                        Width="100%"
                        Height={120}
                      />
                    </Grid>

                    {/* Action Buttons */}
                    <ArgonBox display="flex" justifyContent="center" gap={2} mt={3} width="100%">
                      <ArgonButton
                        variant="outlined"
                        onClick={handleClose}
                        color="secondary"
                        disabled={updateLoading}
                      >
                        Cancel
                      </ArgonButton>
                      <ArgonButton
                        variant="contained"
                        type="submit"
                        color="primary"
                        disabled={updateLoading}
                        startIcon={
                          updateLoading ? <CircularProgress size={16} color="inherit" /> : null
                        }
                      >
                        {updateLoading ? "Saving..." : "Save Changes"}
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </form>
              </ArgonBox>
            </ArgonBox>
          </ArgonBox>
        )}
      </ArgonBox>

      <ArgonBox mt={4}>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Teaching Preferences
          </ArgonTypography>
          <ArgonButton
            onClick={handleTeachingPrefOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Preferences
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows.length > 0 ? (
            <Table columns={columns} rows={rows} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <PersonIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Teaching Preferences Data Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t set any teaching preferences yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      <ArgonBox>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Educational Qualifications
          </ArgonTypography>
          <ArgonButton
            onClick={handleEduQualOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Qualifications
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows1.length > 0 ? (
            <Table columns={columns1} rows={rows1} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <SchoolIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Educational Qualifications Data Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t added any educational qualifications yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      <ArgonBox>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Location Preferences
          </ArgonTypography>
          <ArgonButton
            onClick={handleLocationPrefOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Locations
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows2.length > 0 ? (
            <Table columns={columns2} rows={rows2} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <LocationOnIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Location Preferences Data Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t set any location preferences yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      <ArgonBox>
        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
          <ArgonTypography variant="h5" fontWeight="medium" color="primary">
            Teaching Experience
          </ArgonTypography>
          <ArgonButton
            onClick={handleTeachingExpOpen}
            variant="contained"
            startIcon={<EditIcon />}
            color="info"
            size="small"
          >
            Edit Experience
          </ArgonButton>
        </ArgonBox>
        <ArgonBox
          mt={3}
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {rows3.length > 0 ? (
            <Table columns={columns3} rows={rows3} />
          ) : (
            <Card sx={{ p: 5 }}>
              <ArgonBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <WorkIcon sx={{ fontSize: 64, color: "#d0d0d0" }} />
                <ArgonTypography variant="h6" color="text">
                  No Teaching Experience Data Available
                </ArgonTypography>
                <ArgonTypography variant="caption" color="text" textAlign="center">
                  This tutor hasn&apos;t added any teaching experience yet.
                </ArgonTypography>
              </ArgonBox>
            </Card>
          )}
        </ArgonBox>
      </ArgonBox>

      {/* Teaching Preferences Edit Dialog */}
      {teachingPrefOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 700,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Teaching Preferences
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update subjects, boards and classes you teach
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleTeachingPrefClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            {/* Form Content */}
            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateTeachingPreferences}>
                <Grid container spacing={3}>
                  {teachingPreferences.map((preference, index) => (
                    <Grid item xs={12} key={index}>
                      <ArgonBox
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          p: 3,
                          mb: 2,
                          position: "relative",
                        }}
                      >
                        {/* Remove Button */}
                        {teachingPreferences.length > 1 && (
                          <ArgonButton
                            variant="text"
                            color="error"
                            size="small"
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              minWidth: "auto",
                              width: 30,
                              height: 30,
                              borderRadius: "50%",
                              fontSize: "18px",
                              lineHeight: 1,
                            }}
                            onClick={() => {
                              setTeachingPreferences((prev) => prev.filter((_, i) => i !== index));
                            }}
                          >
                            ×
                          </ArgonButton>
                        )}

                        <ArgonTypography variant="h6" fontWeight="medium" mb={2}>
                          Preference Set {index + 1}
                        </ArgonTypography>

                        <Grid container spacing={2}>
                          {/* Subjects */}
                          <Grid item xs={12} md={4}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Subjects
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={preference?.subject?._id || ""}
                              options={allSubjects}
                              onChange={(e) => {
                                const updated =
                                  teachingPreferences.length > 0 ? [...teachingPreferences] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  subject: { _id: e.target.value },
                                };
                                setTeachingPreferences(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>

                          {/* Boards */}
                          <Grid item xs={12} md={4}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Boards
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={preference?.board?._id || ""}
                              options={allBoards}
                              onChange={(e) => {
                                const updated =
                                  teachingPreferences.length > 0 ? [...teachingPreferences] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  board: { _id: e.target.value },
                                };
                                setTeachingPreferences(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>

                          {/* Classes */}
                          <Grid item xs={12} md={4}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Classes
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={preference?.class?._id || ""}
                              options={allClasses}
                              onChange={(e) => {
                                const updated =
                                  teachingPreferences.length > 0 ? [...teachingPreferences] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  class: { _id: e.target.value },
                                };
                                setTeachingPreferences(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>
                        </Grid>
                      </ArgonBox>
                    </Grid>
                  ))}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => {
                          const newIndex = teachingPreferences.length;
                          setTeachingPreferences([...teachingPreferences, {}]);
                        }}
                      >
                        + Add More Preference
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                {/* Action Buttons */}
                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleTeachingPrefClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={teachingPrefLoading}
                    startIcon={
                      teachingPrefLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {teachingPrefLoading ? "Saving..." : "Save Changes"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Educational Qualifications Edit Dialog */}
      {eduQualOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 800,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Educational Qualifications
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update your educational background
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleEduQualClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateEducationalQualifications}>
                <Grid container spacing={3}>
                  {(eduQualifications.length > 0 ? eduQualifications : [{}]).map((qual, index) => (
                    <Grid item xs={12} key={index}>
                      <ArgonBox sx={{ border: "1px solid #e0e7ff", borderRadius: 2, p: 2, mb: 2 }}>
                        <ArgonTypography variant="h6" mb={2}>
                          Qualification {index + 1}
                        </ArgonTypography>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Class
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={qual?.class?._id || ""}
                              options={allClasses}
                              onChange={(e) => {
                                const updated =
                                  eduQualifications.length > 0 ? [...eduQualifications] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  class: { _id: e.target.value },
                                };
                                setEduQualifications(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Board
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={qual?.board?._id || ""}
                              options={allBoards}
                              onChange={(e) => {
                                const updated =
                                  eduQualifications.length > 0 ? [...eduQualifications] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  board: { _id: e.target.value },
                                };
                                setEduQualifications(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Year of Completion
                            </ArgonTypography>
                            <ArgonInput
                              type="number"
                              value={qual?.completedYear || qual?.yearOfCompletion || ""}
                              onChange={(e) => {
                                const updated =
                                  eduQualifications.length > 0 ? [...eduQualifications] : [{}];
                                const yearValue = e.target.value
                                  ? parseInt(e.target.value, 10)
                                  : "";
                                updated[index] = {
                                  ...updated[index],
                                  completedYear: yearValue,
                                  yearOfCompletion: yearValue,
                                };
                                console.log(`Year updated for qualification ${index}:`, yearValue);
                                setEduQualifications(updated);
                              }}
                              fullWidth
                              placeholder="Enter year (e.g., 2020)"
                              inputProps={{
                                min: 1950,
                                max: new Date().getFullYear(),
                              }}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Institution
                            </ArgonTypography>
                            <ArgonInput
                              value={qual?.schoolUniversity || qual?.schoolUniversityCollege || ""}
                              onChange={(e) => {
                                const updated =
                                  eduQualifications.length > 0 ? [...eduQualifications] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  schoolUniversity: e.target.value,
                                  schoolUniversityCollege: e.target.value,
                                };
                                setEduQualifications(updated);
                              }}
                              fullWidth
                              placeholder="Enter institution name"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Marksheet (Optional)
                            </ArgonTypography>
                            {eduQualMarksheetPreviews[index] && (
                              <ArgonBox mb={2}>
                                <ArgonTypography variant="caption" color="text" mb={1}>
                                  Current Marksheet:
                                </ArgonTypography>
                                <ArgonBox>
                                  <img
                                    src={eduQualMarksheetPreviews[index]}
                                    alt="Current Marksheet"
                                    height="80px"
                                    width="140px"
                                    style={{
                                      border: "1px solid #e0e7ff",
                                      borderRadius: "8px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </ArgonBox>
                              </ArgonBox>
                            )}
                            {eduQualMarksheetFiles &&
                            typeof eduQualMarksheetFiles === "object" &&
                            eduQualMarksheetFiles[index] !== undefined ? (
                              <FileUploader
                                label="Upload New Marksheet"
                                files={
                                  Array.isArray(eduQualMarksheetFiles[index])
                                    ? eduQualMarksheetFiles[index]
                                    : []
                                }
                                setFiles={(updater) => {
                                  console.log(
                                    `Setting files for qualification ${index}:`,
                                    typeof updater
                                  );
                                  setEduQualMarksheetFiles((prev) => {
                                    const currentFiles = Array.isArray(prev[index])
                                      ? prev[index]
                                      : [];
                                    const newFiles =
                                      typeof updater === "function"
                                        ? updater(currentFiles)
                                        : updater;
                                    console.log(
                                      `Updated files for qualification ${index}:`,
                                      newFiles
                                    );
                                    return {
                                      ...prev,
                                      [index]: Array.isArray(newFiles) ? newFiles : [],
                                    };
                                  });
                                }}
                                accept="image/*,application/pdf"
                                multiple={false}
                                Width="100%"
                                Height={120}
                              />
                            ) : (
                              <ArgonTypography variant="caption" color="text">
                                Loading file uploader...
                              </ArgonTypography>
                            )}
                          </Grid>
                        </Grid>
                      </ArgonBox>
                    </Grid>
                  ))}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => {
                          const newIndex = eduQualifications.length;
                          setEduQualifications([...eduQualifications, {}]);
                          setEduQualMarksheetFiles((prev) => ({
                            ...prev,
                            [newIndex]: [],
                          }));
                          console.log(`Added new qualification at index ${newIndex}`);
                        }}
                      >
                        + Add More Qualification
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleEduQualClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={eduQualLoading}
                    startIcon={
                      eduQualLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {eduQualLoading ? "Saving..." : "Save Changes"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Location Preferences Edit Dialog */}
      {locationPrefOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 700,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Location Preferences
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update your preferred teaching locations
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleLocationPrefClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateLocationPreferences}>
                <Grid container spacing={3}>
                  {(locationPreferences.length > 0 ? locationPreferences : [{}]).map(
                    (location, index) => (
                      <Grid item xs={12} key={index}>
                        <ArgonBox
                          sx={{ border: "1px solid #e0e7ff", borderRadius: 2, p: 2, mb: 2 }}
                        >
                          <ArgonBox
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mb={2}
                          >
                            <ArgonTypography variant="h6">Location {index + 1}</ArgonTypography>
                            <ArgonButton
                              variant="text"
                              color="primary"
                              size="small"
                              onClick={() => {
                                setSelectedLocationIndex(index);
                                // Always set map center when clicking - either to existing location or keep current
                                if (location?.lat && location?.lng) {
                                  setMapCenter({
                                    lat: parseFloat(location.lat),
                                    lng: parseFloat(location.lng),
                                  });
                                }
                              }}
                            >
                              📍 Select on Map
                            </ArgonButton>
                          </ArgonBox>

                          {/* Google Map for location selection */}
                          {selectedLocationIndex === index && (
                            <ArgonBox
                              mb={2}
                              sx={{
                                height: "300px",
                                borderRadius: 2,
                                overflow: "hidden",
                                position: "relative",
                              }}
                            >
                              {loadError && (
                                <ArgonBox
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  height="100%"
                                  bgcolor="#f5f5f5"
                                  p={3}
                                >
                                  <ArgonTypography variant="body2" color="error" textAlign="center">
                                    Map cannot be loaded. Please check your internet connection or
                                    try manual entry.
                                  </ArgonTypography>
                                </ArgonBox>
                              )}
                              {!isLoaded && !loadError && (
                                <ArgonBox
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  height="100%"
                                  bgcolor="#f5f5f5"
                                >
                                  <CircularProgress size={40} />
                                </ArgonBox>
                              )}
                              {isLoaded && !loadError && (
                                <GoogleMap
                                  mapContainerStyle={{ width: "100%", height: "100%" }}
                                  center={mapCenter}
                                  zoom={13}
                                  onClick={(e) => {
                                    if (e.latLng) {
                                      const lat = e.latLng.lat();
                                      const lng = e.latLng.lng();
                                      const updated =
                                        locationPreferences.length > 0
                                          ? [...locationPreferences]
                                          : [{}];
                                      updated[index] = {
                                        ...updated[index],
                                        lat: lat,
                                        lng: lng,
                                      };
                                      setLocationPreferences(updated);
                                      setMapCenter({ lat, lng });
                                    }
                                  }}
                                  options={{
                                    streetViewControl: false,
                                    mapTypeControl: false,
                                    fullscreenControl: false,
                                  }}
                                >
                                  {location?.lat && location?.lng && (
                                    <MarkerF position={{ lat: location.lat, lng: location.lng }} />
                                  )}
                                </GoogleMap>
                              )}
                            </ArgonBox>
                          )}

                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                              <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                                Latitude
                              </ArgonTypography>
                              <ArgonInput
                                type="number"
                                value={location?.lat || location?.latitude || ""}
                                onChange={(e) => {
                                  const updated =
                                    locationPreferences.length > 0
                                      ? [...locationPreferences]
                                      : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    lat: e.target.value ? parseFloat(e.target.value) : undefined,
                                  };
                                  setLocationPreferences(updated);
                                  if (e.target.value && updated[index].lng) {
                                    setMapCenter({
                                      lat: parseFloat(e.target.value),
                                      lng: updated[index].lng,
                                    });
                                  }
                                }}
                                fullWidth
                                placeholder="Click on map or enter latitude"
                                inputProps={{ step: "any", min: -90, max: 90 }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                                Longitude
                              </ArgonTypography>
                              <ArgonInput
                                type="number"
                                value={location?.lng || location?.longitude || ""}
                                onChange={(e) => {
                                  const updated =
                                    locationPreferences.length > 0
                                      ? [...locationPreferences]
                                      : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    lng: e.target.value ? parseFloat(e.target.value) : undefined,
                                  };
                                  setLocationPreferences(updated);
                                  if (e.target.value && updated[index].lat) {
                                    setMapCenter({
                                      lat: updated[index].lat,
                                      lng: parseFloat(e.target.value),
                                    });
                                  }
                                }}
                                fullWidth
                                placeholder="Click on map or enter longitude"
                                inputProps={{ step: "any", min: -180, max: 180 }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                                Radius (km)
                              </ArgonTypography>
                              <ArgonInput
                                type="number"
                                value={location?.radius || ""}
                                onChange={(e) => {
                                  const updated =
                                    locationPreferences.length > 0
                                      ? [...locationPreferences]
                                      : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    radius: e.target.value ? parseFloat(e.target.value) : undefined,
                                  };
                                  setLocationPreferences(updated);
                                }}
                                fullWidth
                                placeholder="Enter radius in km"
                                inputProps={{ step: "any", min: 0 }}
                              />
                            </Grid>
                          </Grid>
                        </ArgonBox>
                      </Grid>
                    )
                  )}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => {
                          setLocationPreferences([...locationPreferences, {}]);
                        }}
                      >
                        + Add More Location
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleLocationPrefClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={locationPrefLoading}
                    startIcon={
                      locationPrefLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {locationPrefLoading ? "Saving..." : "Save Changes"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Teaching Experience Edit Dialog */}
      {teachingExpOpen && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 800,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EditIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      Edit Teaching Experience
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Update your teaching experience details
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleTeachingExpClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <form onSubmit={handleUpdateTeachingExperience}>
                <Grid container spacing={3}>
                  {(teachingExperience.length > 0 ? teachingExperience : [{}]).map((exp, index) => (
                    <Grid item xs={12} key={index}>
                      <ArgonBox sx={{ border: "1px solid #e0e7ff", borderRadius: 2, p: 2, mb: 2 }}>
                        <ArgonTypography variant="h6" mb={2}>
                          Experience {index + 1}
                        </ArgonTypography>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Organization *
                            </ArgonTypography>
                            <ArgonInput
                              value={exp?.organization || exp?.institutionOrganization || ""}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  organization: e.target.value,
                                  institutionOrganization: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              placeholder="Enter organization name"
                              required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Position *
                            </ArgonTypography>
                            <ArgonInput
                              value={exp?.position || exp?.positionRole || ""}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  position: e.target.value,
                                  positionRole: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              placeholder="Enter position/role"
                              required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Start Date *
                            </ArgonTypography>
                            <ArgonInput
                              type="date"
                              value={
                                exp?.startDate
                                  ? new Date(exp.startDate).toISOString().split("T")[0]
                                  : ""
                              }
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  startDate: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              required
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              End Date
                            </ArgonTypography>
                            <ArgonInput
                              type="date"
                              value={
                                exp?.endDate
                                  ? new Date(exp.endDate).toISOString().split("T")[0]
                                  : ""
                              }
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  endDate: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              disabled={exp?.isCurrentlyWorking}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Experience Type
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={exp?.experienceType || "TEACHING"}
                              options={[
                                { label: "Teaching", value: "TEACHING" },
                                { label: "Non-Teaching", value: "NON_TEACHING" },
                                { label: "Corporate", value: "CORPORATE" },
                                { label: "Freelance", value: "FREELANCE" },
                                { label: "Other", value: "OTHER" },
                              ]}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  experienceType: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <ArgonBox display="flex" alignItems="center" mt={4}>
                              <input
                                type="checkbox"
                                checked={exp?.isCurrentlyWorking || false}
                                onChange={(e) => {
                                  const updated =
                                    teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                  updated[index] = {
                                    ...updated[index],
                                    isCurrentlyWorking: e.target.checked,
                                    endDate: e.target.checked ? "" : updated[index].endDate,
                                  };
                                  setTeachingExperience(updated);
                                }}
                                style={{ marginRight: "8px" }}
                              />
                              <ArgonTypography variant="body2">Currently Working</ArgonTypography>
                            </ArgonBox>
                          </Grid>
                          <Grid item xs={12}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Description
                            </ArgonTypography>
                            <ArgonInput
                              multiline
                              rows={3}
                              value={exp?.description || exp?.subjectTaught || ""}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  description: e.target.value,
                                  subjectTaught: e.target.value,
                                };
                                setTeachingExperience(updated);
                              }}
                              fullWidth
                              placeholder="Enter job description or subjects taught"
                            />
                          </Grid>

                          {/* Classes Field */}
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Class
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={
                                Array.isArray(exp?.classes) && exp.classes.length > 0
                                  ? exp.classes[0]._id || exp.classes[0]
                                  : exp?.classes?._id || exp?.classes || ""
                              }
                              options={allClasses}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  classes: e.target.value ? [e.target.value] : [],
                                };
                                setTeachingExperience(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>

                          {/* Board Field */}
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Board
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={
                                Array.isArray(exp?.boards) && exp.boards.length > 0
                                  ? exp.boards[0]._id || exp.boards[0]
                                  : exp?.boards?._id || exp?.boards || ""
                              }
                              options={allBoards}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  boards: e.target.value ? [e.target.value] : [],
                                };
                                setTeachingExperience(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>

                          {/* Subject Field */}
                          <Grid item xs={12} sm={6}>
                            <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                              Subject
                            </ArgonTypography>
                            <Dropdown
                              label=""
                              value={
                                Array.isArray(exp?.subjects) && exp.subjects.length > 0
                                  ? exp.subjects[0]._id || exp.subjects[0]
                                  : exp?.subjects?._id || exp?.subjects || ""
                              }
                              options={allSubjects}
                              onChange={(e) => {
                                const updated =
                                  teachingExperience.length > 0 ? [...teachingExperience] : [{}];
                                updated[index] = {
                                  ...updated[index],
                                  subjects: e.target.value ? [e.target.value] : [],
                                };
                                setTeachingExperience(updated);
                              }}
                              width={"100%"}
                            />
                          </Grid>
                        </Grid>
                      </ArgonBox>
                    </Grid>
                  ))}

                  {/* Add More Button */}
                  <Grid item xs={12}>
                    <ArgonBox display="flex" justifyContent="center" mt={2}>
                      <ArgonButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => {
                          setTeachingExperience([...teachingExperience, {}]);
                        }}
                      >
                        + Add More Experience
                      </ArgonButton>
                    </ArgonBox>
                  </Grid>
                </Grid>

                <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                  <ArgonButton variant="outlined" onClick={handleTeachingExpClose}>
                    Cancel
                  </ArgonButton>
                  <ArgonButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={teachingExpLoading}
                    startIcon={
                      teachingExpLoading ? <CircularProgress size={16} color="inherit" /> : null
                    }
                  >
                    {teachingExpLoading ? "Saving..." : "Save Changes"}
                  </ArgonButton>
                </ArgonBox>
              </form>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Evaluation Form Dialog */}
      {openEvaluation && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 900,
              maxHeight: "95vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <ArgonBox
              sx={{
                background: "rgba(255,255,255,0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px 20px 0 0",
                p: 3,
                borderBottom: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonBox display="flex" alignItems="center" gap={2}>
                  <ArgonBox
                    sx={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AssessmentIcon sx={{ color: "white", fontSize: "24px" }} />
                  </ArgonBox>
                  <ArgonBox>
                    <ArgonTypography variant="h5" fontWeight="medium" color="white">
                      {evaluation ? "Edit Tutor Evaluation" : "Add Tutor Evaluation"}
                    </ArgonTypography>
                    <ArgonTypography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
                      Evaluate tutor&apos;s teaching capabilities
                    </ArgonTypography>
                  </ArgonBox>
                </ArgonBox>
                <ArgonButton
                  variant="text"
                  onClick={handleEvaluationClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            {/* Form Content */}
            <ArgonBox sx={{ background: "white", borderRadius: "0 0 20px 20px", p: 4 }}>
              <Grid container spacing={3}>
                {/* Introduction Rating */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Introduction Rating (0-5)
                  </ArgonTypography>
                  <ArgonInput
                    type="number"
                    placeholder="Enter rating (0-5)"
                    value={evaluationForm.introduction}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 0 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, introduction: val });
                    }}
                    fullWidth
                    size="medium"
                    inputProps={{ min: 0, max: 5 }}
                  />
                </Grid>

                {/* English Proficiency */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    English Proficiency
                  </ArgonTypography>
                  <Dropdown
                    label=""
                    value={evaluationForm.english}
                    options={[
                      { label: "Basic", value: "BASIC" },
                      { label: "Intermediate", value: "INTERMEDIATE" },
                      { label: "Fluent", value: "FLUENT" },
                      { label: "Native", value: "NATIVE" },
                    ]}
                    onChange={(e) =>
                      setEvaluationForm({ ...evaluationForm, english: e.target.value })
                    }
                    width="100%"
                  />
                </Grid>

                {/* English Rating */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    English Rating (1-10)
                  </ArgonTypography>
                  <ArgonInput
                    type="number"
                    placeholder="Enter rating (1-10)"
                    value={evaluationForm.englishRating}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, englishRating: val });
                    }}
                    fullWidth
                    size="medium"
                    inputProps={{ min: 1, max: 10 }}
                  />
                </Grid>

                {/* Hindi Rating */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Hindi Rating (1-10)
                  </ArgonTypography>
                  <ArgonInput
                    type="number"
                    placeholder="Enter rating (1-10)"
                    value={evaluationForm.hindiRating}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, hindiRating: val });
                    }}
                    fullWidth
                    size="medium"
                    inputProps={{ min: 1, max: 10 }}
                  />
                </Grid>

                {/* Tone/Pitch */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Tone/Pitch
                  </ArgonTypography>
                  <Dropdown
                    label=""
                    value={evaluationForm.tonePitch}
                    options={[
                      { label: "Low", value: "LOW" },
                      { label: "Medium", value: "MEDIUM" },
                      { label: "High", value: "HIGH" },
                    ]}
                    onChange={(e) =>
                      setEvaluationForm({ ...evaluationForm, tonePitch: e.target.value })
                    }
                    width="100%"
                  />
                </Grid>

                {/* Cross Questions Rating */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Cross Questions Rating (1-10)
                  </ArgonTypography>
                  <TextField
                    type="number"
                    fullWidth
                    value={evaluationForm.crossQuestions}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, crossQuestions: val });
                    }}
                    inputProps={{ min: 1, max: 10 }}
                    size="small"
                  />
                </Grid>

                {/* Confidence Level */}
                <Grid item xs={12} md={6}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Confidence Level (1-10)
                  </ArgonTypography>
                  <TextField
                    type="number"
                    fullWidth
                    value={evaluationForm.confidenceLevel}
                    onChange={(e) => {
                      const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                      setEvaluationForm({ ...evaluationForm, confidenceLevel: val });
                    }}
                    inputProps={{ min: 1, max: 10 }}
                    size="small"
                  />
                </Grid>

                {/* Subject Ratings */}
                <Grid item xs={12}>
                  <ArgonTypography variant="h6" fontWeight="medium" mb={2}>
                    Subject-wise Concept Ratings
                  </ArgonTypography>

                  {evaluationForm.subjectRatings.map((subjectRating, index) => {
                    // Filter to show only tutor's subjects
                    const tutorSubjects = tutor?.subjects || [];
                    const tutorSubjectOptions = allSubjects.filter(
                      (subject) =>
                        tutorSubjects.some((ts) => ts._id === subject.value) &&
                        !evaluationForm.subjectRatings.some(
                          (sr, i) => i !== index && sr.subjectId === subject.value
                        )
                    );

                    return (
                      <Grid container spacing={2} key={index} mb={2} alignItems="flex-end">
                        <Grid item xs={12} md={5}>
                          <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                            Subject
                          </ArgonTypography>
                          <Dropdown
                            label=""
                            value={subjectRating.subjectId || ""}
                            options={tutorSubjectOptions}
                            onChange={(e) => {
                              const updated = [...evaluationForm.subjectRatings];
                              updated[index] = { ...updated[index], subjectId: e.target.value };
                              setEvaluationForm({ ...evaluationForm, subjectRatings: updated });
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={12} md={5}>
                          <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                            Rating (1-10)
                          </ArgonTypography>
                          <TextField
                            type="number"
                            fullWidth
                            value={subjectRating.rating || 1}
                            onChange={(e) => {
                              const val = e.target.value === "" ? 1 : parseInt(e.target.value);
                              const updated = [...evaluationForm.subjectRatings];
                              updated[index] = { ...updated[index], rating: val };
                              setEvaluationForm({ ...evaluationForm, subjectRatings: updated });
                            }}
                            inputProps={{ min: 1, max: 10 }}
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <ArgonButton
                            variant="outlined"
                            color="error"
                            size="small"
                            fullWidth
                            onClick={() => {
                              const updated = evaluationForm.subjectRatings.filter(
                                (_, i) => i !== index
                              );
                              setEvaluationForm({ ...evaluationForm, subjectRatings: updated });
                            }}
                          >
                            Remove
                          </ArgonButton>
                        </Grid>
                      </Grid>
                    );
                  })}

                  <ArgonButton
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => {
                      const tutorSubjects = tutor?.subjects || [];
                      const availableSubjects = allSubjects.filter(
                        (subject) =>
                          tutorSubjects.some((ts) => ts._id === subject.value) &&
                          !evaluationForm.subjectRatings.some(
                            (sr) => sr.subjectId === subject.value
                          )
                      );

                      if (availableSubjects.length === 0) {
                        toast.info("All tutor subjects have been rated or no subjects available");
                        return;
                      }

                      setEvaluationForm({
                        ...evaluationForm,
                        subjectRatings: [
                          ...evaluationForm.subjectRatings,
                          { subjectId: "", rating: 1 },
                        ],
                      });
                    }}
                  >
                    + Add Subject Rating
                  </ArgonButton>
                </Grid>

                {/* Teaching Methods */}
                <Grid item xs={12}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Teaching Methods
                  </ArgonTypography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6} ml={1.5}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={evaluationForm.startingFromBasics}
                            onChange={(e) =>
                              setEvaluationForm({
                                ...evaluationForm,
                                startingFromBasics: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Starting from Basics"
                      />
                    </Grid>
                    <Grid item xs={12} md={5} ml={1.5}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={evaluationForm.smoothExplanations}
                            onChange={(e) =>
                              setEvaluationForm({
                                ...evaluationForm,
                                smoothExplanations: e.target.checked,
                              })
                            }
                          />
                        }
                        label="Smooth Explanations"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Speech Impediment */}
                <Grid item xs={12}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6} ml={1.5}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={evaluationForm.lisp}
                            onChange={(e) =>
                              setEvaluationForm({ ...evaluationForm, lisp: e.target.checked })
                            }
                          />
                        }
                        label="Speech Impediment (Lisp)"
                      />
                    </Grid>

                    {/* Lisp Category */}
                    {evaluationForm.lisp && (
                      <Grid item xs={12} md={6}>
                        <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                          Speech Impediment Category
                        </ArgonTypography>
                        <ArgonInput
                          fullWidth
                          placeholder="Enter category"
                          value={evaluationForm.lispCategory}
                          onChange={(e) =>
                            setEvaluationForm({ ...evaluationForm, lispCategory: e.target.value })
                          }
                          size="small"
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>

                {/* Personality Assessment */}
                <Grid item xs={12}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Personality Assessment
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    placeholder="Enter personality assessment"
                    value={evaluationForm.personalityWise}
                    onChange={(e) =>
                      setEvaluationForm({ ...evaluationForm, personalityWise: e.target.value })
                    }
                    size="small"
                  />
                </Grid>

                {/* Remarks */}
                <Grid item xs={12}>
                  <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                    Remarks
                  </ArgonTypography>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Enter remarks"
                    value={evaluationForm.remarks}
                    onChange={(e) =>
                      setEvaluationForm({ ...evaluationForm, remarks: e.target.value })
                    }
                    size="small"
                  />
                </Grid>
              </Grid>

              <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                <ArgonButton variant="outlined" onClick={handleEvaluationClose}>
                  Cancel
                </ArgonButton>
                <ArgonButton
                  variant="contained"
                  color="info"
                  onClick={handleEvaluationSubmit}
                  disabled={savingEvaluation}
                  startIcon={
                    savingEvaluation ? <CircularProgress size={16} color="inherit" /> : null
                  }
                >
                  {savingEvaluation ? "Saving..." : "Submit"}
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}

      {/* Approval/Rejection Dialog */}
      {openApprovalDialog && (
        <ArgonBox
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <ArgonBox
            sx={{
              background: "white",
              borderRadius: "20px",
              width: "90%",
              maxWidth: 600,
              maxHeight: "90vh",
              overflowY: "auto",
              boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <ArgonBox
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "20px 20px 0 0",
                p: 3,
              }}
            >
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                <ArgonTypography variant="h5" fontWeight="medium" color="white">
                  Approve or Reject Tutor
                </ArgonTypography>
                <ArgonButton
                  variant="text"
                  onClick={handleApprovalDialogClose}
                  sx={{
                    color: "white",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "rgba(255,255,255,0.1)",
                    "&:hover": { background: "rgba(255,255,255,0.2)" },
                  }}
                >
                  ×
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>

            {/* Form Content */}
            <ArgonBox sx={{ p: 4 }}>
              <Grid container spacing={3}>
                {/* Approval Status Selection */}
                <Grid item xs={12}>
                  <ArgonTypography variant="body2" fontWeight="bold" mb={2}>
                    Select Action
                  </ArgonTypography>
                  <Box display="flex" gap={2}>
                    <ArgonButton
                      variant={
                        approvalForm.approvalStatus === "APPROVED" ? "contained" : "outlined"
                      }
                      color="success"
                      onClick={() =>
                        setApprovalForm({ ...approvalForm, approvalStatus: "APPROVED" })
                      }
                      fullWidth
                    >
                      Approve
                    </ArgonButton>
                    <ArgonButton
                      variant={
                        approvalForm.approvalStatus === "REJECTED" ? "contained" : "outlined"
                      }
                      color="error"
                      onClick={() =>
                        setApprovalForm({ ...approvalForm, approvalStatus: "REJECTED" })
                      }
                      fullWidth
                    >
                      Reject
                    </ArgonButton>
                  </Box>
                </Grid>

                {/* Approved Fields */}
                {approvalForm.approvalStatus === "APPROVED" && (
                  <>
                    <Grid item xs={12}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Level/Badge
                      </ArgonTypography>
                      <Dropdown
                        label=""
                        value={approvalForm.badgeLevel}
                        options={[
                          { label: "🥉 Level 1", value: "Level 1" },
                          { label: "🥈 Level 2", value: "Level 2" },
                          { label: "🥇 Level 3", value: "Level 3" },
                          { label: "💎 Level 4", value: "Level 4" },
                        ]}
                        onChange={(e) =>
                          setApprovalForm({ ...approvalForm, badgeLevel: e.target.value })
                        }
                        width="100%"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Salary (₹/hour)
                      </ArgonTypography>
                      <ArgonInput
                        type="number"
                        fullWidth
                        placeholder="Enter hourly rate"
                        value={approvalForm.hourlyRate}
                        onChange={(e) =>
                          setApprovalForm({ ...approvalForm, hourlyRate: e.target.value })
                        }
                        size="small"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                        Edushala Margin (%)
                      </ArgonTypography>
                      <ArgonInput
                        type="number"
                        fullWidth
                        placeholder="Enter margin"
                        value={approvalForm.edushalaMargin}
                        onChange={(e) =>
                          setApprovalForm({ ...approvalForm, edushalaMargin: e.target.value })
                        }
                        size="small"
                      />
                    </Grid>
                  </>
                )}

                {/* Rejected Fields */}
                {approvalForm.approvalStatus === "REJECTED" && (
                  <Grid item xs={12}>
                    <ArgonTypography variant="body2" fontWeight="medium" mb={1}>
                      Rejection Reason *
                    </ArgonTypography>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      placeholder="Enter reason for rejection"
                      value={approvalForm.rejectionReason}
                      onChange={(e) =>
                        setApprovalForm({ ...approvalForm, rejectionReason: e.target.value })
                      }
                      size="medium"
                    />
                  </Grid>
                )}
              </Grid>

              <ArgonBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
                <ArgonButton variant="outlined" onClick={handleApprovalDialogClose}>
                  Cancel
                </ArgonButton>
                <ArgonButton
                  variant="contained"
                  color={approvalForm.approvalStatus === "APPROVED" ? "success" : "error"}
                  onClick={handleApprovalSubmit}
                  disabled={approvalLoading || !approvalForm.approvalStatus}
                  startIcon={
                    approvalLoading ? <CircularProgress size={16} color="inherit" /> : null
                  }
                >
                  {approvalLoading ? "Submitting..." : "Submit"}
                </ArgonButton>
              </ArgonBox>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}
    </ArgonBox>
  );
}

export default BasicDetails;
